import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button} from "@mui/material";
import dogFlow from "./icons/dog_flower.jpeg"
import dogFlow2 from "./icons/dog_flower_2.jpeg"
import dogFlow3 from "./icons/dog_flower_3.jpeg"
import dogFlow4 from "./icons/dog_flower_4.jpeg"
import dogFlow5 from "./icons/dog_flower_5.jpeg"
import dogsBaloonSummer from "./icons/dogs_baloon_summer.png"
import dogsBaloonWinter from "./icons/dogs_baloon_winter.png"
import dogsBaloonSpring from "./icons/dogs_baloon_spring.png"
import dogsBaloonFall from "./icons/dogs_baloon_fall.png"
export default function WeddingDialog(props) {

    const dogs = [dogFlow, dogFlow2, dogFlow3, dogFlow4, dogFlow5, dogsBaloonSummer,
        dogsBaloonWinter, dogsBaloonFall, dogsBaloonSpring
    ]

    const [slideNum, setSlideNum] = React.useState(0)
    const [dogNum, setDogNum] = React.useState(0)
    const setOpen = props.handelOpen

    const randomize = () => {
        let new_im = 0
        for (let index = 0; index < 10; index++) {
            new_im = Math.floor( dogs.length*Math.random())
            if(new_im !== dogNum) {
                break
            }           
        }
        setDogNum(new_im)
    }


    const dialogsContents = [
        <DialogContentText>Are you Dasha?</DialogContentText>,
        <div>
            <DialogContentText>Хорошая моя, я очень тебя люблю!</DialogContentText>
            <DialogContentText>Годы с тобой были самыми счастливыми годами моей жизни!</DialogContentText>
        </div>,
        <div>
            <DialogContentText>Это тебе!!!</DialogContentText>
            <img onDoubleClick = {randomize} src={dogs[dogNum]} width={400}/>
            <DialogContentText style={{fontSize:10}}>(double click to update)</DialogContentText>
        </div>
        ]

    const nSlides = dialogsContents.length
    const nextSlide = () => {
        console.log("nextSlide, befor: slideNum = ", slideNum, " nSlides=", nSlides)
        if(slideNum > nSlides-2) {
            setOpen(false)
        }
        else if(slideNum === nSlides-2) {
            randomize()
            setSlideNum(slideNum+1)
        }
        else {
            setSlideNum(slideNum+1)
        }
        console.log("nextSlide, after: slideNum = ", slideNum)
    }

    const previousSlide = () => {
        if(slideNum === 0) {
            setOpen(false)
        }
        else {
            setSlideNum( slideNum-1)
        }
    }

    return    <Dialog
        open = {props.open}>
        <DialogTitle>Weddings</DialogTitle>
        <DialogContent>{dialogsContents[slideNum]}</DialogContent>
        <DialogActions>
            <Button onClick={() => {
                setOpen(false);
                setSlideNum(0); 
                }}>No</Button>
            <Button onClick={previousSlide}>Back</Button>
            <Button onClick={nextSlide}>Yes</Button>
        </DialogActions>
    </Dialog>

}